import React, { Component } from "react";
import PropTypes from "prop-types";
import Dropzone from "react-dropzone";

import { translate } from "admin-on-rest";
import ActionAdd from "material-ui/svg-icons/content/add";
import FlatButton from "material-ui/FlatButton";
import CircularProgress from "material-ui/CircularProgress";
import Snackbar from "material-ui/Snackbar";
import { red500, grey800 } from "material-ui/styles/colors";

import { UploadClient } from "../restClient";
//import { cyan500 } from "material-ui/styles/colors";

//const ERROR_MESSAGE_MAX_SIZE = "Please resize your image less then 1MB";
const ERROR_MESSAGE_FAILED = "Upload File failed";

class ImportButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      openSnackBar: false,
      color: red500,
      message: "Please try again"
    };
  }
  handleRequestClose = () => {
    this.setState({
      openSnackBar: false
    });
  };
  onDrop = (accepted, rejected) => {
    if (accepted.length > 0 && rejected.length === 0) {
      this.setState({
        isLoading: true
      });
      let formData = new FormData();
      accepted.forEach(file => {
        formData.append("file", file, file.name);
      });
      if(this.props.agencyid){
        const id = this.props.agencyid * 1;
        const url = `/agencyMarketers/${id}/import`;
        UploadClient(formData, url)
          .then(response => response.json())
          .then(data => {
            // console.log(data);
            //this.onAdd(data.url);
            this.props.onUpload(data);
            this.setState({
              isLoading: false,
              openSnackBar: true,
              color: grey800,
              message: "File Uploaded"
            });
          })
          .catch(e => {
            //console.log('masuk sini',e.message);
            this.setState({
              isLoading: false,
              openSnackBar: true,
              color: red500,
              message: ERROR_MESSAGE_FAILED
            });
          });
      }
      
    }
  };
  render() {
    const {
      accept,
      // children,
      disableClick,
      maxSize,
      minSize,
      multiple
      // style,
    } = this.props;
    const { isLoading, color } = this.state;

    const label = isLoading ? "" : "Import CSV";
    return (
      <div>
        <Dropzone
          onDrop={this.onDrop}
          accept={accept}
          disableClick={disableClick}
          maxSize={maxSize}
          minSize={minSize}
          multiple={multiple}
          style={{ width: "100%", height: "auto" }}
        >
          <FlatButton
            primary={true}
            label={label}
            icon={
              isLoading ? (
                <CircularProgress size={25} thickness={2} />
              ) : (
                <ActionAdd />
              )
            }
          />
        </Dropzone>
        <Snackbar
          open={this.state.openSnackBar}
          message={this.state.message}
          autoHideDuration={4000}
          bodyStyle={{ backgroundColor: color }}
          onRequestClose={this.handleRequestClose}
        />
      </div>
    );
  }
}

ImportButton.propTypes = {
  basePath: PropTypes.string,
  label: PropTypes.string,
  record: PropTypes.object,
  translate: PropTypes.func.isRequired,
  urlPath: PropTypes.string,
  accept: PropTypes.string,
  children: PropTypes.element,
  disableClick: PropTypes.bool,
  elStyle: PropTypes.object,
  input: PropTypes.object,
  maxSize: PropTypes.number,
  minSize: PropTypes.number,
  multiple: PropTypes.bool,
  style: PropTypes.object,
  placeholder: PropTypes.node,
  agencyid: PropTypes.string.isRequired,
  onUpload: PropTypes.func
};
ImportButton.defaultProps = {
  addLabel: false,
  addField: true,
  multiple: false,
  maxSize: 2000000,
  onUpload: () => {}
};
export default translate(ImportButton);



// WEBPACK FOOTER //
// ./src/agency/ImportButton.js